/* Stimara cold-traffic lander (Sol V3) — shared behavior.
   Loaded by several lander sections; the guard below makes duplicate
   script tags harmless. Re-inits on Shopify theme editor section loads. */
(function () {
  if (window.__stimaraLanderInit) return;
  window.__stimaraLanderInit = true;

  document.documentElement.classList.add('sol-js');

  /* Document top of an element from layout, ignoring transforms: an
     unrevealed .sol-reveal target is still slid 20px down, so its
     getBoundingClientRect (and scrollIntoView) would land 20px off. */
  function layoutTop(el) {
    var top = 0;
    for (; el; el = el.offsetParent) top += el.offsetTop;
    return top;
  }

  /* The theme header, while it is pinned to the top of the screen (lander
     store nav on). Jumps stop just below it instead of underneath it. */
  function stickyHeaderHeight() {
    var header = document.querySelector('.shopify-section.header-section');
    if (!header) return 0;
    var style = getComputedStyle(header);
    if (style.display === 'none' || (style.position !== 'sticky' && style.position !== 'fixed')) return 0;
    return header.offsetHeight;
  }
  var ANCHOR_GAP = 8;

  /* Hash-link clicks on Sol pages scroll programmatically (capture phase),
     so third-party scripts can't swallow the default anchor navigation. */
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
    if (!link || !link.closest('.sol-lander, .sol-home')) return;
    var id = link.getAttribute('href').slice(1);
    var target = id ? document.getElementById(id) : null;
    if (!target) return;
    /* zero-height helper anchors (e.g. #choose) scroll to the section that follows them */
    if (!target.offsetHeight) {
      var host = target.closest('.shopify-section');
      if (host && host.nextElementSibling) target = host.nextElementSibling;
    }
    event.preventDefault();
    event.stopPropagation();
    var top = layoutTop(target) - stickyHeaderHeight() - ANCHOR_GAP;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }, true);

  /* ---- Shipping countdown (resets to the next cutoff hour in the given time zone) ---- */
  function initCountdown(root) {
    if (root.dataset.solReady) return;
    root.dataset.solReady = 'true';

    var zone = root.getAttribute('data-timezone') || 'America/Chicago';
    var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour') || '13', 10);

    function zoneParts(date) {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: zone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hourCycle: 'h23'
      });
      var out = {};
      fmt.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') out[part.type] = Number(part.value);
      });
      return out;
    }

    function offsetAt(date) {
      var p = zoneParts(date);
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - date.getTime();
    }

    function zonedToUtc(year, month, day, hour, minute, second) {
      var base = Date.UTC(year, month - 1, day, hour, minute, second);
      var first = base - offsetAt(new Date(base));
      var secondPass = base - offsetAt(new Date(first));
      return new Date(secondPass);
    }

    function isBusinessDate(localDate) {
      var day = localDate.getUTCDay();
      return day >= 1 && day <= 5;
    }

    function nextCutoff(now) {
      var p = zoneParts(now);
      var localDate = new Date(Date.UTC(p.year, p.month - 1, p.day));
      var target = zonedToUtc(p.year, p.month, p.day, cutoffHour, 0, 0);
      if (!isBusinessDate(localDate) || now.getTime() >= target.getTime()) {
        do {
          localDate.setUTCDate(localDate.getUTCDate() + 1);
        } while (!isBusinessDate(localDate));
        target = zonedToUtc(localDate.getUTCFullYear(), localDate.getUTCMonth() + 1, localDate.getUTCDate(), cutoffHour, 0, 0);
      }
      return target;
    }

    var hoursEl = root.querySelector('[data-hours]');
    var minutesEl = root.querySelector('[data-minutes]');
    var secondsEl = root.querySelector('[data-seconds]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    var target = nextCutoff(new Date());
    function updateCountdown() {
      var now = new Date();
      if (now.getTime() >= target.getTime()) target = nextCutoff(now);
      var seconds = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
      hoursEl.textContent = String(Math.floor(seconds / 3600)).padStart(2, '0');
      minutesEl.textContent = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      secondsEl.textContent = String(seconds % 60).padStart(2, '0');
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ---- "Where they earn their place" moment tabs ---- */
  function initMoments(root) {
    if (root.dataset.solReady) return;
    root.dataset.solReady = 'true';

    var tabs = root.querySelectorAll('[data-moment-tab]');
    var panels = root.querySelectorAll('[data-moment-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-moment-tab');
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-moment-panel') !== key;
        });
      });
    });
  }

  /* ---- Review filter tabs ---- */
  function initReviews(root) {
    if (root.dataset.solReady) return;
    root.dataset.solReady = 'true';

    var tabs = root.querySelectorAll('[data-review-tab]');
    var cards = root.querySelectorAll('[data-review-category]');

    function activate(tab) {
      var key = tab.getAttribute('data-review-tab');
      tabs.forEach(function (item) { item.classList.toggle('active', item === tab); });
      cards.forEach(function (card) {
        card.hidden = card.getAttribute('data-review-category') !== key;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab); });
    });
    if (tabs.length) activate(tabs[0]);
  }

  /* ---- Sticky buy bar (shows past the hero; hides over the buy section or any visible CTA) ---- */
  function initSticky(root) {
    if (root.dataset.solReady) return;
    root.dataset.solReady = 'true';

    var bar = root.querySelector('[data-sticky-bar]') || root.querySelector('.sol-sticky-buy');
    if (!bar) return;
    var targetSelector = root.getAttribute('data-hide-over');

    /* track every other CTA button on the page; the bar stays hidden while one is on screen */
    var watched = [];
    document.querySelectorAll('.sol-btn, .home-btn').forEach(function (el) {
      if (!bar.contains(el)) watched.push(el);
    });
    if ('IntersectionObserver' in window && watched.length) {
      var ctaObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.target.__solCtaVisible = entry.isIntersecting; });
        update();
      }, { threshold: 0.05 });
      watched.forEach(function (el) { ctaObserver.observe(el); });
    }
    function anyCtaVisible() {
      for (var i = 0; i < watched.length; i++) {
        if (watched[i].__solCtaVisible) return true;
      }
      return false;
    }

    function update() {
      var hero = document.querySelector('.sol-hero, .home-hero, .sol12-hero');
      var pastHero = hero ? window.scrollY > hero.offsetHeight * 0.75 : window.scrollY > 600;
      var overShop = false;
      if (targetSelector) {
        var shop = document.querySelector(targetSelector);
        if (shop) {
          var parent = shop.closest('.shopify-section') || shop;
          /* zero-height helper anchors (e.g. #choose) stand in for the section
             that follows them — watch that section, or the bar reappears while
             the shopper is still inside the buy box */
          if (!parent.offsetHeight && parent.nextElementSibling) parent = parent.nextElementSibling;
          var rect = parent.getBoundingClientRect();
          overShop = rect.top < window.innerHeight && rect.bottom > 0;
        }
      }
      bar.classList.toggle('show', pastHero && !overShop && !anyCtaVisible());
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  /* ---- Count-up stats (numbers race to their value when scrolled into view) ---- */
  function initCountup(root) {
    if (root.dataset.solCountReady) return;
    root.dataset.solCountReady = 'true';

    var els = root.querySelectorAll('[data-countup]');
    if (!els.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var raw = el.textContent;
        var match = raw.match(/\d[\d,]*/);
        if (!match) return;
        var target = parseInt(match[0].replace(/,/g, ''), 10);
        var prefix = raw.slice(0, match.index);
        var suffix = raw.slice(match.index + match[0].length);
        var duration = 900;
        var start = null;
        function step(timestamp) {
          if (start === null) start = timestamp;
          var t = Math.min(1, (timestamp - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3);
          el.textContent = prefix + Math.round(target * eased) + suffix;
          if (t < 1) requestAnimationFrame(step);
        }
        el.textContent = prefix + '0' + suffix;
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Reveal-on-scroll ---- */
  var revealObserver = null;
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.sol-reveal').forEach(function (item) { item.classList.add('in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
    }
    document.querySelectorAll('.sol-reveal:not(.in)').forEach(function (item) { revealObserver.observe(item); });
  }

  /* Isolate each init: the page adds `sol-js` (which hides every .sol-reveal)
     before any of these run, and initReveal is what fades them back in. If an
     earlier init threw (e.g. a bad data-timezone → Intl RangeError), initReveal
     never ran and the whole page below the fold stayed invisible. Per-init
     try/catch guarantees one failure can't take down the rest — initReveal
     especially always runs. */
  function safeInit(fn) {
    try { fn(); } catch (e) { if (window.console && console.warn) console.warn('[sol] init error', e); }
  }
  function initAll() {
    safeInit(function () { document.querySelectorAll('[data-sol-countdown]').forEach(initCountdown); });
    safeInit(function () { document.querySelectorAll('[data-sol-moments]').forEach(initMoments); });
    safeInit(function () { document.querySelectorAll('[data-sol-reviews]').forEach(initReviews); });
    safeInit(function () { document.querySelectorAll('[data-sol-sticky]').forEach(initSticky); });
    safeInit(function () { document.querySelectorAll('[data-sol-countup]').forEach(initCountup); });
    safeInit(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () {
    initAll();
    /* make freshly re-rendered editor sections visible immediately */
    document.querySelectorAll('.sol-reveal:not(.in)').forEach(function (item) { item.classList.add('in'); });
  });
})();
